import { render, staticRenderFns } from "./SectionLayout.vue?vue&type=template&id=640d0a82&scoped=true&"
import script from "./SectionLayout.vue?vue&type=script&lang=ts&"
export * from "./SectionLayout.vue?vue&type=script&lang=ts&"
import style0 from "./SectionLayout.vue?vue&type=style&index=0&id=640d0a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640d0a82",
  null
  
)

export default component.exports